<template>
    <back-button :route="{ name: 'finnancial.anticipation-control' }"/>
    <div class="flex items-center my-3">
        <h2 class="ml-2 dark:text-white text-lg capitalize tex font-bold">
            Antecipação #{{ storeAnticipation.id }}
        </h2>
    </div>
    <div class="grid grid-cols-3 gap-4">
        <div class="col-span-2">
            <div
                class="border border-black/5 dark:border-white/10 min-w-0 w-full rounded-xl overflow-hidden bg-white dark:bg-white/[0.02] mb-4 shadow-xs"
            >
                <div
                    class="border border-black/5 dark:border-white/10 min-w-0 w-full rounded-xl overflow-hidden bg-white dark:bg-white/[0.02] mb-4 shadow-xs p-5"
                >
                    <div
                        class="grid grid-cols-4 mb-4 gap-3"
                        v-if="storeAnticipation"
                    >
                        <div class="flex flex-col">
                            <span
                                class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                                >USUÁRIO</span
                            >
                            <span class="text-gray-800 dark:text-gray-200">
                                {{ storeAnticipation.user.name }}
                            </span>
                        </div>
                        <div class="flex flex-col">
                            <span
                                class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                                >E-MAIL</span
                            >
                            <span class="text-gray-800 dark:text-gray-200">
                                {{ storeAnticipation.user.email }}
                            </span>
                        </div>
                        <div class="flex flex-col">
                            <span
                                class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                                >NATUREZA</span
                            >
                            <span class="text-gray-800 dark:text-gray-200">
                                {{
                                    storeAnticipation.user.company_type ===
                                    "company"
                                        ? "JURÍDICA"
                                        : "FÍSICA"
                                }}
                            </span>
                        </div>
                        <div class="flex flex-col">
                            <span
                                class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                                >CPF/CNPJ</span
                            >
                            <span class="text-gray-800 dark:text-gray-200">
                                {{
                                    storeAnticipation.user.company_type ===
                                    "company"
                                        ? formatCnpj(
                                              storeAnticipation.user.cnpj
                                          )
                                        : formatCpf(storeAnticipation.user.cpf)
                                }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="border border-black/5 dark:border-white/10 min-w-0 w-full rounded-xl overflow-hidden bg-white dark:bg-white/[0.02] mb-4 shadow-xs p-5"
            >
                <div
                    class="grid grid-cols-4 mb-4 gap-3"
                    v-if="storeAnticipation"
                >
                    <div class="flex flex-col">
                        <span
                            class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                            >VALOR SOLICITADO</span
                        >
                        <span class="text-gray-800 dark:text-gray-200">
                            {{ $root.formatCurrency(storeAnticipation.amount) }}
                        </span>
                    </div>
                    <div class="flex flex-col">
                        <span
                            class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                            >TAXA APLICADA</span
                        >
                        <span class="text-gray-800 dark:text-gray-200">
                            {{ $root.formatCurrency(storeAnticipation.fee) }}
                        </span>
                    </div>
                    <div class="flex flex-col">
                        <span
                            class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                            >VALOR A RECEBER</span
                        >
                        <span
                            class="text-gray-800 dark:text-gray-200 font-bold"
                        >
                            {{
                                $root.formatCurrency(
                                    storeAnticipation.net_value
                                )
                            }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div
                class="border border-black/5 dark:border-white/10 min-w-0 w-full rounded-xl overflow-hidden bg-white dark:bg-white/[0.02] mb-4 flex shadow-xs p-5"
            >
                <div class="flex flex-row">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500 mr-4"
                        >STATUS</span
                    >
                    <span
                        :class="getCashoutStatusClass(storeAnticipation.status)"
                        class="text-gray-800 dark:text-gray-200 px-2 py-1 rounded"
                    >
                        {{ getCashoutStatusName(storeAnticipation.status) }}
                    </span>
                </div>
            </div>
            <div
                class="border border-black/5 dark:border-white/10 min-w-0 w-full rounded-xl overflow-hidden bg-white dark:bg-white/[0.02] mb-4 flex shadow-xs p-5"
            >
                <div class="flex w-full" role="status" v-if="loading">
                    <svg
                        aria-hidden="true"
                        class="mx-auto w-8 h-8 text-gray-200 animate-spin dark:text-gray-400 fill-blue-600"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor"
                        />
                        <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill"
                        />
                    </svg>
                    <span class="sr-only">Loading...</span>
                </div>
                <ol
                    v-else
                    class="relative border-l border-gray-200 dark:border-gray-700 w-full"
                >
                    <li class="mb-10 ml-4" v-for="status in statuses">
                        <div
                            class="absolute w-3 h-3 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900"
                            :class="getStatusClass(status.status)"
                        ></div>
                        <time
                            class="mb-1 text-sm font-normal leading-none text-gray-200 dark:text-gray-500"
                            >{{ status.created_at }}</time
                        >
                        <h3
                            class="text-lg font-semibold text-gray-900 dark:text-white"
                        >
                            {{ status.status }}
                        </h3>
                        <p
                            class="text-base font-normal text-gray-500 dark:text-gray-200"
                        >
                            {{ status.user.name }} {{ status.user.email }}
                        </p>
                        <p
                            class="bg-slate-900 p-4 mt-1 rounded-lg text-base font-normal text-gray-500 dark:text-gray-200"
                        >
                            {{ status.description }}
                        </p>
                    </li>
                    <li class="ml-4">
                        <div
                            class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"
                        ></div>
                        <time
                            class="mb-1 text-sm font-normal leading-none text-gray-200 dark:text-gray-500"
                        >
                            {{ storeAnticipation.created_at }}
                        </time>
                        <h3
                            class="text-lg font-semibold text-gray-900 dark:text-white"
                        >
                            Antecipação Solicitada
                        </h3>

                    </li>
                </ol>
            </div>

        </div>
    </div>
</template>

<script>
import VueSelect from "../../../components/forms/VueSelect.vue";
import ProductStatus from "../../../components/layouts/ProductStatus.vue";
import { mapWritableState, mapActions } from "pinia";
import { Store } from "../../../stores/store.js";
import { TransitionRoot } from "@headlessui/vue";
import HelperMixin from "../../../mixins/HelperMixin.vue";
import BankMixin from "../../../mixins/BankMixin.vue";
import BackButton from "../../../components/layouts/navigation/BackButton.vue";

export default {
    components: {BackButton, VueSelect, ProductStatus, TransitionRoot },
    mixins: [HelperMixin, BankMixin],
    data() {
        return {
            loading: false,
            statuses: [],
            form: {
                status: false,
                description: "",
            },
        };
    },

    computed: {
        ...mapWritableState(Store, ["storeAnticipation"]),
    },

    mounted() {
        this.fetchAnticipation();
    },

    methods: {
        ...mapActions(Store, ["fetchAnticipation"]),
        clearFilters() {
            this.bankAccounts = [];
            this.filters.status = [];
            this.filters.types = [];
            this.next_page_url = false;
            this.fetch();
        },
    },
};
</script>
